import { useEffect, useState } from 'react'

export interface MediaQueryBreakpoint<T> {
    query: string
    value: T
}

export const useResponsiveValue = <T>(breakpoints: MediaQueryBreakpoint<T>[], defaultValue: T): T => {
    const [value, setValue] = useState(defaultValue)

    useEffect(() => {
        const handleResize = () => {
            for (const breakpoint of breakpoints) {
                if (globalThis.matchMedia(breakpoint.query).matches) {
                    setValue(breakpoint.value)
                    return
                }
            }
            setValue(defaultValue)
        }

        // Call it once to set the initial value
        handleResize()

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [breakpoints, defaultValue])

    return value
}

const breakpoints = [
    { query: '(max-width: 399px)', value: 1.25 },
    { query: '(min-width: 400px) and (max-width: 519px)', value: 1.5 },
    { query: '(min-width: 520px) and (max-width: 639px)', value: 1.75 },
    { query: '(min-width: 640px) and (max-width: 767px)', value: 2 },
    { query: '(min-width: 768px) and (max-width: 1023px)', value: 3 },
    { query: '(min-width: 1024px)', value: 4 },
]

export const useResponsiveCards = () => {
    return useResponsiveValue(breakpoints, 1.5)
}
